<template>
  <nav aria-label="breadcrumb">
    <div class="d-flex align-items-center gap-3">
    <router-link
      v-if="backTo"
      :to="backTo"
      class="breadcrumb-back"
      :class="headerTextClass"
    >
      <i class="fas fa-chevron-left" aria-hidden="true"></i>
      Back to campaign
    </router-link>
    <ol
      class="breadcrumb-trail px-0 py-0 mb-0 bg-transparent breadcrumb"
      :class="headerTextClass"
    >
      <li class="text-sm breadcrumb-item">
        <a 
        :class="this.$store.state.isNavFixed ? 'text-dark' : 'text-white'"
         class="opacity-8" href="#">Pages</a>
      </li>
      <li
        v-for="(page,pageIndex) in pageRoute" :key="page"
        class="text-sm breadcrumb-item active"
        :class="[headerTextClass, { 'font-weight-bolder': pageIndex == pageRoute.length - 1 }]"
        :aria-current="pageIndex == pageRoute.length-1 ? 'page' : ''"
      >
        {{ page }}
      </li>
    </ol>
    </div>
  </nav>
</template>

<script>
export default {
  name: "breadcrumbs",
  props: {
    currentPage: {
      required: true
    },
    pageRoute: {
      required: true
    },
    textWhite: {
      type: String
    }
  },
  computed: {
    headerTextClass() {
      return this.$store.state.isNavFixed ? "text-dark" : "text-white";
    },
    backTo() {
      const campaignID = this.$route.params.campaignID;
      const reportingPages = [
        "Campaign reporting",
        "Campaign BLS reporting",
        "Creative reporting"
      ];
      if (!campaignID || !reportingPages.includes(this.$route.name)) return null;
      return { name: "Campaign view", params: { campaignID } };
    }
  }
};
</script>

<style scoped>
.breadcrumb-back {
  display: inline-flex;
  align-items: center;
  gap: 0.4rem;
  flex: 0 0 auto;
  margin: 0;
  padding: 0.45rem 0.95rem;
  border: 1px solid currentColor;
  border-radius: 0.5rem;
  background: transparent;
  font-size: 0.95rem;
  font-weight: 600;
  line-height: 1.2;
  text-decoration: none;
  white-space: nowrap;
}

.breadcrumb-back:hover {
  background: color-mix(in srgb, currentColor 14%, transparent);
}

.breadcrumb-trail {
  align-items: center;
  line-height: 1.2;
}

.breadcrumb-trail :deep(.breadcrumb-item) {
  display: flex;
  align-items: center;
}

.breadcrumb-trail :deep(.breadcrumb-item + .breadcrumb-item::before) {
  float: none;
}
</style>
